import { Node, ReactNodeViewRenderer } from "@tiptap/react";

import AiVariable from "./AiVariable";

export default Node.create({
  name: "aiVariable",

  addNodeView() {
    return ReactNodeViewRenderer(AiVariable);
  },

  group: "inline",

  inline: true,

  atom: true,

  addAttributes() {
    return {
      id: {
        isRequired: true,
        default: false,
        parseHTML: (element) => element.getAttribute("data-id"),
        renderHTML: (attrs) => ({
          "data-id": attrs.id,
        }),
      },
      description: {
        isRequired: true,
        default: false,
        parseHTML: (element) => element.getAttribute("data-description"),
        renderHTML: (attrs) => ({
          "data-description": attrs.description,
        }),
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", { ...HTMLAttributes, "data-type": "ai-variable" }];
  },
});
